// Supabase client singleton pour le front (dashboard).
// Source : PRD 03 §3 auth + PRD 09 §3 stack.
//
// Pattern : UNE instance réutilisée partout. Le SDK Supabase gère la session
// via onAuthStateChange — pas besoin de multiple clients. flowType PKCE pour
// OAuth (Google) + bearer tokens short-lived.
//
// SÉCURITÉ : uniquement ANON_KEY côté front (RLS gated). La service_role key
// est réservée aux workers Node / edge functions / scripts.
import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { getEnv } from "./env";

let cached: SupabaseClient | undefined;

export function getSupabaseClient(): SupabaseClient {
  if (cached) return cached;
  const env = getEnv();
  cached = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
    auth: {
      flowType: "pkce",
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: typeof window !== "undefined" ? window.localStorage : undefined,
    },
    global: {
      headers: {
        "X-Client-Info": "xymail-v2-dashboard",
      },
    },
  });
  return cached;
}

/** Convenience export : singleton instance. */
export const supabase = getSupabaseClient();
